import { Component, OnInit, HostListener, ViewChild, DoCheck } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { Settings } from 'src/app/app.settings.model';

@Component({
  selector: 'app-slider-selectable',
  templateUrl: './slider-selectable.component.html',
  styleUrls: ['./slider-selectable.component.scss']
})
export class SliderSelectableComponent implements OnInit, DoCheck {
  // protected bxSliderList: any;
  configurations: any;
  settings: Settings;
  arrowDisplayer: boolean = true;
  @ViewChild(PerfectScrollbarDirective)
  directiveRef?: PerfectScrollbarDirective;
  translate: TranslateService;
  constructor(private appSettings: AppSettings) {
    this.settings = this.appSettings.settings;
  }
  ngDoCheck() {
    if (!this.directiveRef.scrollable('x')) {
      this.arrowDisplayer = false;
    } else {
      this.arrowDisplayer = true;
    }
    this.directiveRef.update();
  }
  ngOnInit() {
    this.configurations = {
      suppressScrollX: false
    };
  }

  goRight() {
    if (this.directiveRef.scrollable('x'))
      this.directiveRef.scrollToX(this.directiveRef.geometry().x + 115, 300);
      this.directiveRef.update();
  }
  goLeft() {
    if (this.directiveRef.scrollable('x'))
      this.directiveRef.scrollToX(this.directiveRef.geometry().x - 115, 300);
      this.directiveRef.update();
  }
  trackBy(item: any): any {
    return item.id;
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (!this.directiveRef.scrollable('x')) {
      this.arrowDisplayer = false;
    } else {
      this.arrowDisplayer = true;
    }
    this.directiveRef.update();
  }
}
